import React from 'react';

function AppleLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7 fill-white" aria-hidden="true">
      <path d="M16.36 12.78c.02 2.6 2.28 3.46 2.3 3.47-.02.06-.36 1.24-1.19 2.46-.72 1.05-1.46 2.1-2.64 2.12-1.15.02-1.53-.68-2.85-.68-1.32 0-1.74.66-2.83.7-1.13.05-2-1.13-2.72-2.18-1.49-2.15-2.62-6.07-1.1-8.72.76-1.31 2.11-2.14 3.58-2.16 1.12-.02 2.17.75 2.85.75.68 0 1.96-.93 3.3-.79.56.02 2.14.23 3.16 1.71-.08.05-1.88 1.1-1.86 3.27M14.2 5.04c.6-.73 1.01-1.74.9-2.75-.87.03-1.92.58-2.55 1.31-.56.64-1.05 1.67-.92 2.65.97.08 1.96-.49 2.57-1.21" />
    </svg>
  );
}

function PlayLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden="true">
      <path d="M3.6 2.1c-.3.2-.5.6-.5 1.1v17.6c0 .5.2.9.5 1.1l9.5-9.9L3.6 2.1Z" fill="#34d399" />
      <path d="M17 8.4 13.1 6 3.6 2.1 13.1 12 17 8.4Z" fill="#fbbf24" />
      <path d="M17 15.6 13.1 12 3.6 21.9 13.1 18 17 15.6Z" fill="#f87171" />
      <path d="M20.6 10.7 17 8.4 13.1 12l3.9 3.6 3.6-2.3c.9-.5.9-2.1 0-2.6Z" fill="#60a5fa" />
    </svg>
  );
}

function Badge({ logo, top, bottom }) {
  return (
    <div
      className="group inline-flex cursor-default items-center gap-3 rounded-2xl border border-white/12 bg-white/[0.04] px-5 py-3 backdrop-blur-sm transition duration-300 hover:border-ember-500/40 hover:bg-white/[0.07]"
      role="img"
      aria-label={`${top} ${bottom} — coming soon`}
    >
      <span className="shrink-0">{logo}</span>
      <span className="flex flex-col leading-tight text-left">
        <span className="text-[0.6rem] font-medium uppercase tracking-[0.18em] text-white/45">
          {top}
        </span>
        <span className="font-display text-base font-semibold text-white">
          {bottom}
        </span>
      </span>
    </div>
  );
}

// "Coming soon" mobile app badges for iOS and Android (apps not yet released).
export default function AppBadges() {
  return (
    <div className="flex flex-col items-center">
      <p className="mb-4 inline-flex items-center gap-2 text-sm text-white/50">
        <span className="h-px w-6 bg-gradient-to-r from-transparent to-ember-500/60" />
        Also launching on mobile
        <span className="h-px w-6 bg-gradient-to-l from-transparent to-ember-500/60" />
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Badge logo={<AppleLogo />} top="Coming soon to" bottom="App Store" />
        <Badge logo={<PlayLogo />} top="Coming soon to" bottom="Google Play" />
      </div>
    </div>
  );
}
